"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const RangeSlider = ({ className, disabled, max, min, onChange, value }) => {
    const activeTrackScale = min === max ? 0 : (value - min) / (max - min);
    return (react_1.default.createElement("div", { className: "znd-range-slider" },
        react_1.default.createElement("input", { className: (0, classnames_1.default)('custom-range znd-range-slider__input', className), type: "range", min: min, max: max, value: value, onChange: (event) => onChange(Number(event.target.value)), disabled: disabled }),
        react_1.default.createElement("div", { className: "znd-range-slider__active-track" },
            react_1.default.createElement("div", { className: "znd-range-slider__active-bar", style: {
                    transform: `scaleX(${activeTrackScale})`,
                } }))));
};
exports.default = RangeSlider;
